import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-loader-rbac',
  templateUrl: './loader-rbac.component.html',
  styleUrl: './loader-rbac.component.scss'
})
export class LoaderRbacComponent {

}
